import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentImage from 'images/funnels/document.png';
import NoteImage from 'images/funnels/note.png';
import ModalMC from '../../../components/ModalMC';
import ButtonComponent from '../../../components/ButtonMC';
import TitleMC from '../../../components/TitleMC';
import { META_BUSINESS_URL, META_FLOWS_DOCS_URL } from '../../../../constants/WhatsappFlowTemplateCategories';

const WhatsappFlowCreationModalMC = ({
  visible,
  onClose,
  onPressCreateFromTemplate
}) => {
  const { t } = useTranslation('WhatsappFlowsScreenMC');

  const handleCreateInMeta = () => {
    window.open(META_BUSINESS_URL, '_blank', 'noopener,noreferrer');
    window.open(META_FLOWS_DOCS_URL, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <ModalMC
      visible={visible}
      onClose={onClose}
      containerClassName="!tw-max-w-2xl"
      className="tw-px-8 tw-pb-14 tw-pt-8"
    >
      <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4">
        <TitleMC
          text={t('creation_modal.title')}
          textClassName="tw-w-full tw-text-center tw-text-xl"
        />
        <div className="tw-w-full tw-text-center tw-text-xs tw-py-3">
          {t('creation_modal.subtitle')}
        </div>
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
          <CardComponent
            title={t('creation_modal.card_template.title')}
            imageSrc={DocumentImage}
            imageAlt={t('creation_modal.card_template.title')}
            description={t('creation_modal.card_template.description')}
            buttonText={t('creation_modal.card_template.button')}
            onPress={onPressCreateFromTemplate}
          />
          <CardComponent
            title={t('creation_modal.card_meta.title')}
            imageSrc={NoteImage}
            imageAlt={t('creation_modal.card_meta.title')}
            description={t('creation_modal.card_meta.description')}
            buttonText={t('creation_modal.card_meta.button')}
            onPress={handleCreateInMeta}
            variant="SECONDARY"
            outlined
          />
        </div>
      </div>
    </ModalMC>
  );
};

const CardComponent = ({
  title,
  imageSrc,
  imageAlt,
  description,
  buttonText,
  onPress,
  variant = 'PRIMARY',
  outlined = false
}) => (
  <div className="tw-w-full md:tw-w-1/2 tw-p-8 tw-rounded-3xl tw-border tw-border-gray-300 tw-flex tw-flex-col tw-justify-between tw-items-center tw-gap-4 tw-min-h-full">
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-flex-grow">
      <TitleMC textClassName="tw-w-full tw-text-center tw-text-base" text={title} variant="H1_SEMIBOLD" />
      <div className="tw-w-[70px]">
        <img src={imageSrc} alt={imageAlt} />
      </div>
      <div className="tw-w-full tw-h-auto tw-text-center tw-text-xs">
        {description}
      </div>
    </div>
    <ButtonComponent
      text={buttonText}
      onClick={onPress}
      className="tw-w-full tw-text-sm !tw-px-0"
      variant={variant}
      outlined={outlined}
    />
  </div>
);

export default WhatsappFlowCreationModalMC;
